import { render, staticRenderFns } from "./VaultPeopleModal.vue?vue&type=template&id=50ea900f"
import script from "./VaultPeopleModal.vue?vue&type=script&lang=js"
export * from "./VaultPeopleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports